import React from 'react';
import IntegrationDocTemplate from '../../../../components/IntegrationDocTemplate';

export default function DocsFlexport() {
  return (
    <IntegrationDocTemplate
      title="Flexport"
      category="Warehousing · 3PL · Freight"
      status="beta"
      summary="Enterprise logistics platform — freight + parcel + customs + global trade docs. REST API with OpenAPI3 spec. Best for cross-border merchants and businesses moving containerload (LTL/FTL) volumes."
      prerequisites={[
        'Flexport account (apply at flexport.com).',
        'API credentials from Flexport portal.',
        'Use case fit: international freight, ocean/air, customs clearance.',
      ]}
      connectSteps={[
        'Send us your Flexport credentials via Talk to Sales (enterprise onboarding).',
        'We configure shipment tracking + parcel fulfillment + customs documentation flow.',
        'First sync: open shipments + container + ASN events.',
      ]}
      syncedData={[
        { type: 'Shipments', detail: 'Container/SKU-level tracking; vessel + ETA + customs clearance' },
        { type: 'Freight orders', detail: 'LTL/FTL booking + tracking' },
        { type: 'Customs', detail: 'Commercial invoices + packing lists + HTS classification' },
        { type: 'Parcel fulfillment', detail: 'Domestic parcel via Flexport (post-Deliverr acquisition)' },
      ]}
      agents={[
        { id: 'shipment_tracking_agent', name: 'shipment_tracking_agent', role: 'Container + parcel tracking' },
        { id: 'head_supply_chain', name: 'head_supply_chain', role: 'Director coordinating international supply chain' },
      ]}
      troubleshooting={[
        { question: 'Complex implementation', answer: 'Flexport is enterprise-grade. Most merchants need 4-8 weeks of integration. Consider starting with Flexport just for ocean freight + use ShipBob/MCF for last-mile.' },
      ]}
      supportLink="/contact"
    />
  );
}
